import React, { useEffect, useState } from "react";
import { IoCamera } from "react-icons/io5";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import trans from "../../utils";
import Button from "../Helpers/Button/Button";
export default function SnippetCamera({
	item,
	addData,
	setSubmitData,
	submitData,
	preview,
}) {
	const [camera, setCamera] = useState(false);
	const [value, setValue] = useState("");
	const currentValue = addData
		? (submitData?.find((i) => i.key === item.key)?.value ?? "")
		: (item?.value ?? value ?? "");
	const validate = addData
		? item?.required?.value && currentValue === ""
		: item?.required?.value && currentValue === "";
	const handleChange = (e) => {
		if (addData) {
			setSubmitData((prev) => {
				// Remove existing item with same key if you want to replace it
				const filtered = prev?.filter((i) => i.key !== item.key) || [];
				return [
					...filtered,
					{
						key: item.key,
						name: item.name,
						title: item.title,
						value: e,
					},
				];
			});
			setCamera(!camera);
		}
	};
	const handleClear = () => {
		setCamera(false);
		setValue(null);
		if (addData) {
			setSubmitData((prev) =>
				prev ? prev.filter((i) => i.key !== item.key) : [],
			);
		}
	};
	useEffect(() => {
		if (submitData?.length > 0) {
			const file = submitData?.find((i) => i.name === "Camera");
			setValue(file);
		}
	}, [submitData]);
	console.log("FILE", value);
	return (
		<>
			<label
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
				htmlFor={item?.key || "camera"}
				className="form-label d-block"
			>
				<div className="d-flex align-items-center">
					{item?.title}
					{item?.required?.value && value === "" && (
						<div className="text-danger ms-2">*</div>
					)}
				</div>
			</label>
			<IoCamera
				onClick={() => setCamera(!camera)}
				style={{ cursor: "pointer", height: "40px", width: "40px" }}
			/>
			{((addData && value) || item?.value) && (
				<div className="d-flex align-items-end">
					<img
						src={value?.value || item?.value}
						alt="file"
						style={{
							width: "300px",
							height: "300px",
							borderRadius: "8px",
							display: "block",
						}}
					/>
					<Button type="default" onClick={handleClear} className="mx-2">
						{trans("Clear")}
					</Button>
				</div>
			)}
			{preview !== true ? (
				<>
					{validate && (
						<div className="text-danger mt-1">
							{trans(item?.required?.validationMessage)}
						</div>
					)}
				</>
			) : (
				""
			)}
			{camera && <Camera onTakePhoto={(e) => handleChange(e)} />}
		</>
	);
}
